module.exports = __webpack_public_path__ + "static/client_6-14c68b177e43b535658f6f015064b716.png";